<template>
  <div>
    <!-- Page content -->
    <section class="py-6">
      <b-container>
        <h2 class="h2 font-weight-900 pb-3 pt-3 d-lg-none">DEVELOPPE TES COMPETENCES</h2>
        <b-row align-v="center" class="content-center">
          <b-col :lg="item.fullWidth?12:6" :key="item.id" v-for="(item, index) in shares" class="mb-lg-4 mb-3">
            <b-card class="shares mb-lg-4">
              <b-link :href="data.shares[index].url" target="_blank">
                <span class="h2 font-weight-900 mb-0 d-none d-lg-block" v-html="$t(item.title)"></span>
                <b-row align-v="center" class="details">
                  <b-col align="center" align-v="center" :lg="item.fullWidth?2:3" sm="3" class="pl-0 pr-0">
                    <i class="icon"><b-img class="" alt="..." :src="item.icon" /></i>
                  </b-col>
                  <b-col align="left" align-v="center" :lg="item.fullWidth?10:9" sm="9" class="pl-0">
                    <span class="h3 font-weight-900 mb-0 d-block d-lg-none" v-html="$t(item.title)"></span>
                    <p v-html="$t(item.description)"></p>
                  </b-col>
                </b-row>
              </b-link>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import data from '../../../datas';
export default {
  name: 'Share',
  data() {
    return {
      data,
      shares: [
        {
          id: 1,
          title: "shares.app-1.title",
          description: "shares.app-1.description",
          icon: "./img/theme/shares/catalogue.png"
        },
        {
          id: 2,
          title: "shares.app-2.title",
          description: "shares.app-2.description",
          icon: "./img/theme/shares/meet_up.png"
        },
        {
          id: 3,
          title: "shares.app-3.title",
          description: "shares.app-3.description",
          icon: "./img/theme/shares/ieat_academy.png"
        },
        {
          id: 4,
          title: "shares.app-4.title",
          description: "shares.app-4.description",
          icon: "./img/theme/shares/blog_ineat.png"
        },
        /*
        {
          id: 5,
          title: "shares.app-5.title",
          description: "shares.app-5.description",
          icon: "./img/theme/shares/catalogue.png"
        },
        {
          id: 6,
          title: "shares.app-6.title",
          description: "shares.app-6.description",
          icon: "./img/theme/shares/meet_up.png"
        },
        {
          id: 7,
          title: "shares.app-7.title",
          description: "shares.app-7.description",
          icon: "./img/theme/shares/participe.png",
          fullWidth: true
        }
        */
      ]
    }
  }  
};
</script>
